import React from "react";
import { SelectedStockCountItemContext } from "./context";

export const useSelectedStockCountItemContextProvider = () => {
  const context = React.useContext(SelectedStockCountItemContext);
  if (!context) {
    throw new Error(
      "SelectedStockCountItemContext must be used within a SelectedStockCountItemContext"
    );
  }
  return context;
};
